import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router";
import "./Header.scss";
import NoImage from "../../assets/images/no-image-avatar.png";
import { useUserContext } from "../../context/UserContext";
import Down from "../../assets/images/DownarrowB.svg";
import { IMAGE_URL, DEFAULT_PROFILE_IMAGE } from "../../app_url";
import { onLogout } from "../../utils/commonData";
import { Menu, X } from "lucide-react";
import PatientSearchWithFilters from "../PatientSearch/PatientSearchWithFilters";
import NotificationBell from "./NotificationBell";

const DashboardDoctorHeader = ({ hideWelcome = false, hideSearch = false, hideProfile = false }) => {
  const { userData, setUserData, sidebarDrawerOpen, setSidebarDrawerOpen } = useUserContext();
  const navigate = useNavigate();
  const location = useLocation();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const isDashboardOrAppointments = location.pathname.includes("/doctor/dashboard") || location.pathname.includes("/doctor/appointments");

  const Logout = () => {
    onLogout();
    setUserData(null);
    navigate("/");
  };

  return (
    <div className={`doctorHdr ${isDashboardOrAppointments ? "dashboard-appointments-header" : ""} ${hideWelcome && hideSearch && hideProfile ? "header-hidden" : ""}`}>
      <div className="lftHeader">
        <button className="hamburger_menu" onClick={() => setSidebarDrawerOpen(!sidebarDrawerOpen)}>
          {sidebarDrawerOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        {!hideWelcome && <h2>Welcome {userData?.users?.first_name}</h2>}
      </div>

      <div className="rgtHeader">
        {!hideProfile && (
          <>
            <NotificationBell />
            <div className="profile-menu">
              <div className="profile-header" onClick={toggleDropdown}>
                <img
                  src={userData?.users?.profile_pic_url ? userData?.users?.profile_pic_url : '/' + DEFAULT_PROFILE_IMAGE}
                  className="profile-picture custom-skeleton"
                  alt="Profile Picture"
                />
                <span className="profile-name">
                  {userData?.users?.first_name} {userData?.users?.last_name}
                </span>
                <button className="dropdown-toggle">
                  <img src={Down} className="Downarrow" alt="icon" />
                </button>
              </div>
              {isDropdownOpen &&
                (userData?.users?.type === "Nurse" ? (
                  <div className="dropdown-content">
                    <Link to="/nurse/account">My account</Link>
                    <Link to="/nurse/help-center">Help center</Link>
                    <Link to={"javascript:void(0);"} onClick={Logout}>
                      Logout
                    </Link>
                  </div>
                ) : (
                  <div className="dropdown-content">
                    <Link to="/doctor/profile">My profile</Link>
                    <Link to="/doctor/account">My account</Link>
                    <Link to="/doctor/workspace-config">Workspace config</Link>
                    <Link to="/doctor/prescription-management">Prescription management</Link>
                    <Link to="/doctor/subscription">Subscription</Link>
                    <Link to="/doctor/help-center">Help center</Link>
                    <Link to={"javascript:void(0);"} onClick={Logout}>
                      Logout
                    </Link>
                  </div>
                ))}
            </div>
          </>
        )}

        {!hideSearch && (
          <>
            <div className="mobileSearch">
              <button className="searchicon" onClick={() => setShowMobileSearch(!showMobileSearch)}>
                Search
              </button>
            </div>
            <PatientSearchWithFilters
              showMobileSearch={showMobileSearch}
            />
          </>
        )}
      </div>
    </div >
  );
};

export default DashboardDoctorHeader;
